import React from 'react';
import { APITypes } from '../../../../../primary-record-types';
import Stack from '../../../../v2BaseComponents/Stack';
import urls from '../../../../../utils/urls';
import { getFallbackFromName, LoadableAvatar } from '../../../../v2BaseComponents/Avatar';
import Text from '../../../../v2BaseComponents/Text';
import { getCollaboratorName, isOrganizationCollaborator } from '../../../../../utils/collaboratorUtils';
import Chip from '../../../../v2BaseComponents/Chip';
import { getIntl } from '../../../../../utils/intl';

const intl = getIntl('profile-collaborator-details-collaborator-header', {
    professional: 'Professional',
});

type CollaboratorHeaderProps = {
    medicalProfileId: string;
    collaboratorId: string;
    collaborator?: APITypes.medicalProfileService.MedicalProfileCollaborator;
};

const CollaboratorHeader: React.FC<CollaboratorHeaderProps> = ({ medicalProfileId, collaboratorId, collaborator }) => {
    return (
        <Stack
            horizontal
            fullWidth
            align="center"
            justify="flex-start"
            space={4}
            testID="collaborator-header-container"
        >
            <LoadableAvatar
                avatarUrl={urls.api.collaborators.collaboratorAvatar(medicalProfileId, collaboratorId)}
                size="md"
                fallbackName={collaborator ? getFallbackFromName(getCollaboratorName(collaborator)) : ''}
            />
            <Stack vertical>
                <Text variant="h4">{collaborator ? getCollaboratorName(collaborator) : ''}</Text>
                {collaborator && isOrganizationCollaborator(collaborator) ? (
                    <Chip title={intl('professional')} />
                ) : null}
            </Stack>
        </Stack>
    );
};

export default React.memo(CollaboratorHeader);
